import { InputInterface, TypeInput } from '../../types/Exa_Input'

/* eslint-disable @typescript-eslint/no-explicit-any */
export const namespaced = true


export const state: InputInterface = {
    id: 0,
    ref: '',
    libelle: '',
    description: '',
    type: 1,
    ordre: 0,
    requis: false,
    data: null,
    condition: null,
    value: null, 
    anomalie: ''
}

export const mutations = {
    RESET_STATE (state: InputInterface) {
        Object.assign(state, {
            id: 0,
            ref: '',
            libelle: '',
            description: '',
            type: 1,
            ordre: 0,
            requis: false,
            data: null,
            condition: null,
            value: null,
            anomalie: ''
        })
    },  
    SET_ID (state: InputInterface, id: number) {
        state.id = id
    },
    SET_REF (state: InputInterface, ref: string) {
        state.ref = ref
    },
    SET_LIBELLE (state: any, libelle: string) {
        state.libelle = libelle
    },
    SET_DESCRIPTION (state: any, description: string) {
        state.description = description
    },
    SET_TYPE (state: any, type: TypeInput) {
        state.type = type
    },    
    SET_ORDRE (state: any, ordre: number) {
        state.ordre = ordre
    },
    SET_REQUIS (state: any, requis: boolean) {
        state.requis = requis
    },
    SET_DATA (state: any, data: any) {
        state.data = data
    },
    SET_CONDITION (state: any, condition: any) {
        state.condition = condition
    }  
}

export const actions = {
    loadInput({ commit }: { commit: any }, input: InputInterface) {
        commit('SET_ID', input.id)
        commit('SET_REF', input.ref)
        commit('SET_LIBELLE', input.libelle)
        commit('SET_DESCRIPTION', input.description)
        commit('SET_TYPE', input.type)
        commit('SET_ORDRE', input.ordre)
        commit('SET_REQUIS', input.requis)
        commit('SET_DATA', input.data)
        commit('SET_CONDITION', input.condition)
    }
}

export const getters = {
    libelle: (state: InputInterface) => {
        return state.libelle
    },
    ref: (state: InputInterface) => {
        return state.ref
    },
    description: (state: InputInterface) => {
        return state.description
    },
    type: (state: InputInterface) => {
        return state.type
    },
    ordre: (state: InputInterface) => {
        return state.ordre
    },
    requis: (state: InputInterface) => {
        return state.requis
    },
    data: (state: InputInterface) => {
        return state.data
    },
    condition: (state: InputInterface) => {
        return state.condition
    }

}
